export default function () {
  this.loadCoupons()
}
